import { Nav } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import CompanyManagement from "../../organisms/CompanyManagement";
import BranchManagement from "../../organisms/BranchManagement";
import ChiefAdmin from "../../organisms/ChiefAdmin";
import { useSelector } from "react-redux";

export default function AdminSetting() {
    const { type } = useParams();
    const navigate = useNavigate();
    const loginInfo = useSelector(state => state.login);

    return (
        <>
            <h1 className="page-title">관리자 설정</h1>

            <Nav className="nav-tabs" activeKey={type}
                onSelect={(activeKey) => {
                    navigate("../list/"+activeKey)
                }}
            >
                {
                    loginInfo.admin.level < 3 &&
                    <Nav.Item>
                        <Nav.Link eventKey={`company`}>업체 관리</Nav.Link>
                    </Nav.Item>
                }
                {
                loginInfo.admin.level < 4 &&
                <Nav.Item>
                    <Nav.Link eventKey={`branch`}>지점 관리</Nav.Link>
                </Nav.Item>
                }
                {
                    loginInfo.admin.level == 1 &&
                    <Nav.Item>
                        <Nav.Link eventKey={`chief`}>최고 관리자</Nav.Link>
                    </Nav.Item>
                }
            </Nav>
            {
                type == "company" &&
                <CompanyManagement />
            }
            {
                type == "branch" &&
                <BranchManagement/>
            }
            {
                type == "chief" &&
                <ChiefAdmin/>
            }
        </>
    );
}
